// extracted by mini-css-extract-plugin
export default {"detail":"ProductDetail_detail__YO3kD"};